import { ROUTES_SERVICE } from "@/services/routes.service.js";

const state = {postRouteOutput: false, getRoutesOutput: {}, putRouteOutput: false, deleteRouteByIdOutput: false, getRouteByIdOutput: {}};

const actions = {
    //Service to create routes
    postRoute({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postRouteRequest');

        ROUTES_SERVICE.postRoute(input)
            .then(
                output => {
                    commit('postRouteSuccess', output);
                },
                error => {
                    commit('postRouteFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated Routes
    getRoutes({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getRoutesRequest');

        ROUTES_SERVICE.getRoutes(queryParams)
            .then(
                output => {
                    commit('getRoutesSuccess', output);
                },
                error => {
                    commit('getRoutesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update Routes
    putRoute({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putRouteRequest');

        ROUTES_SERVICE.putRoute(input)
            .then(
                output => {
                    commit('putRouteSuccess', output);
                },
                error => {
                    commit('putRouteFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to remove routes
    deleteRouteById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteRouteByIdRequest');

        ROUTES_SERVICE.deleteRouteById(id)
            .then(
                output => {
                    commit('deleteRouteByIdSuccess', output);
                },
                error => {
                    commit('deleteRouteByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get route details
    getRouteById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getRouteByIdRequest');

        ROUTES_SERVICE.getRouteById(id)
            .then(
                output => {
                    commit('getRouteByIdSuccess', output);
                },
                error => {
                    commit('getRouteByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postRoute
    postRouteRequest(state) {
        state.postRouteOutput = null;
    },
    postRouteSuccess(state, output) {
        state.postRouteOutput = true;
    },
    postRouteFailure(state) {
        state.postRouteOutput = false;
    },

    //getRoutes
    getRoutesRequest(state) {
    },
    getRoutesSuccess(state, output) {
        state.getRoutesOutput = output;
    },
    getRoutesFailure(state) {
        state.getRoutesOutput = false;
    },

    //putRoute
    putRouteRequest(state) {
        state.putRouteOutput = null;
    },
    putRouteSuccess(state, output) {
        state.putRouteOutput = true;
    },
    putRouteFailure(state) {
        state.putRouteOutput = false;
    },

    //deleteRouteById
    deleteRouteByIdRequest(state) {
        state.deleteRouteByIdOutput = null;
    },
    deleteRouteByIdSuccess(state, output) {
        state.deleteRouteByIdOutput = true;
    },
    deleteRouteByIdFailure(state) {
        state.deleteRouteByIdOutput = false;
    },

    //getRouteById
    getRouteByIdRequest(state) {
    },
    getRouteByIdSuccess(state, output) {
        state.getRouteByIdOutput = output;
    },
    getRouteByIdFailure(state) {
        state.getRouteByIdOutput = false;
    },
};

export const routes = {
    namespaced: true,
    state,
    actions,
    mutations
};